<i18n src="@/locales/modules/DeviceAccessoryTranslate.json"></i18n>

<template>
	<div>
		<el-dialog class="custom-dialog todo-detail-dialog" append-to-body destroy-on-close :visible.sync="isSidebarActiveLocal">
			<div slot="title" class="w-full flex justify-between mr-4">
				<div>
					<h4 class="uppercase font-bold block text-xl w-full">{{ $t("DetailAccessory", { accessoryTypeName: this.accessoryTypeName }) }}</h4>
					<p class="text-base text-black font-medium">{{ device ? device.name : "" }}</p>
				</div>
				<DeviceAccessoryContextMenu
					:device="device"
					:accessory="accessory"
					@onClickEdit="data => $emit('onClickEdit', data)"
					@onClickDelete="data => $emit('onClickDelete', data)"
					@onClickCreateTodo="data => $emit('onClickCreateTodo', data)"
					@onClickCreateRequest="data => $emit('onClickCreateRequest', data)"
				/>
			</div>
			<div class="p-6">
				<vs-row class="mb-2">
					<vs-col vs-w="4" vs-xs="6">
						<label for>{{ $t("AccessoryName", { accessoryTypeName: this.accessoryTypeName }) }}:</label>
					</vs-col>
					<vs-col vs-w="8" vs-xs="6" class="text-black">{{ localAccessory.name }}</vs-col>
				</vs-row>
				<vs-row class="mb-2">
					<vs-col vs-w="4" vs-xs="6">
						<label for>{{ $t("AccessoryCode", { accessoryTypeName: this.accessoryTypeName }) }}:</label>
					</vs-col>
					<vs-col vs-w="8" vs-xs="6" class="text-black">{{ localAccessory.code }}</vs-col>
				</vs-row>
				<vs-row class="mb-2">
					<vs-col vs-w="4" vs-xs="6">
						<label for>{{ $t("MaintainHour") }}:</label>
					</vs-col>
					<vs-col vs-w="8" vs-xs="6" class="text-black">{{ $helper.numFormat(localAccessory.maintain_hrs) }}</vs-col>
				</vs-row>
				<!-- TotalHrs -->
				<vs-row class="mb-2">
					<vs-col vs-w="4" vs-xs="6">
						<label for>{{ $t("TotalHrs") }}:</label>
					</vs-col>
					<vs-col vs-w="8" vs-xs="6" class="text-black">{{ $helper.numFormat(localAccessory.total_hrs) }}</vs-col>
				</vs-row>
				<!-- CurrentHrs -->
				<vs-row class="mb-2">
					<vs-col vs-w="4" vs-xs="6">
						<label for>{{ $t("CurrentHrs") }}:</label>
					</vs-col>
					<vs-col vs-w="8" vs-xs="6" class="text-black">{{ $helper.numFormat(localAccessory.current_hrs) }}</vs-col>
				</vs-row>
				<vs-row class="mb-2" v-if="localAccessory.description">
					<vs-col vs-w="4" vs-xs="6">
						<label for>{{ $t("Description") }}:</label>
					</vs-col>
					<vs-col vs-w="8" vs-xs="6" class="text-black">{{ localAccessory.description }}</vs-col>
				</vs-row>
				<!-- Tags -->
				<vs-row class="mb-2" v-if="localAccessory.tags">
					<vs-col vs-w="4" vs-xs="6">
						<label for>{{ $t("Tag") }}:</label>
					</vs-col>
					<vs-col vs-w="8" vs-xs="6" class="text-black">{{ tags }}</vs-col>
				</vs-row>
				<!-- Attachments -->
				<vs-row class="mb-2" v-if="(localAccessory.files && localAccessory.files.length > 0) || localAccessory.can_attach_files">
					<vs-col vs-w="4">
						<label class="text-solid-gray-1">{{ $t("Attachments") }}:</label>
					</vs-col>
					<vs-col vs-w="8" class="text-black">
						<cbs-upload-ref v-if="localAccessory.files" :isEditable="false" v-model="localAccessory.files" :key="accessory.id" />
					</vs-col>
				</vs-row>
			</div>
			<!-- Collapse Current Task -->
			<el-collapse v-if="showLogsCurrentTodo" class="cbs-collapse mt-0">
				<el-collapse-item name="GeneralInfo">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("CurrentTask") }}</h6>
						</div>
					</template>
					<div class="px-6">
						<LogsTodoByRelations
							@TotalTodoList="
								total => {
									this.handleShowCollape(total, 'showLogsCurrentTodo');
								}
							"
							ref="logs-current-todo"
							v-if="isSidebarActive"
							:statuses="[0, 1, 4, 6]"
							:relations="[{ id: accessory.id, type: 'Accessory' }]"
						/>
					</div>
				</el-collapse-item>
			</el-collapse>
			<!-- End Current Task -->

			<!-- Collapse Histories Task -->
			<el-collapse v-if="showLogsDoneTodo" class="cbs-collapse mt-0">
				<el-collapse-item name="GeneralInfo">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("LogsTask") }}</h6>
						</div>
					</template>
					<div class="px-6">
						<LogsTodoByRelations
							@TotalTodoList="
								total => {
									this.handleShowCollape(total, 'showLogsDoneTodo');
								}
							"
							ref="logs-done-todo"
							v-if="isSidebarActive"
							:limit="5"
							:statuses="[5]"
							:relations="[{ id: accessory.id, type: 'Accessory' }]"
						/>
					</div>
				</el-collapse-item>
			</el-collapse>
			<!-- End Histories Task -->
		</el-dialog>
	</div>
</template>

<script>
import DeviceAccessoryContextMenu from "../../views/apps/cbs/device/DeviceAccessoryContextMenu";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";

import { mapGetters } from "vuex";
import LogsTodoByRelations from "@/components/logs-todo-by-relations/LogsTodoByRelations";

export default {
	name: "AccessoryDetailDialog",
	components: { DeviceAccessoryContextMenu, CbsUploadRef, LogsTodoByRelations },

	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		accessory: {
			type: Object,
			default: () => {}
		},
		device: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			showLogsCurrentTodo: true,
			showLogsDoneTodo: true
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar", val);
				}
			}
		},
		accessoryTypeName() {
			switch (this.accessory.type_id) {
				case this.$constant.ACCESSORY_TYPE.ACCESSORY:
					return this.$t("Accessory").toLowerCase();

				case this.$constant.ACCESSORY_TYPE.MATERIAL:
					return this.$t("Material").toLowerCase();

				default:
					break;
			}
		},
		...mapGetters({
			getParsedAccessory: "deviceManagement/getParsedAccessory"
		}),
		localAccessory() {
			const accessory = this.getParsedAccessory(this.accessory);
			return accessory ? accessory : {};
		},
		tags() {
			const _t = this.accessory.tags.map(item => item.name);
			return _t.toString();
		}
	},
	methods: {
		handleShowCollape(total, name) {
			this[name] = total > 0 ? true : false;
		}
	}
};
</script>

<style></style>
